import { motion } from 'framer-motion';
import React from 'react';

import { modalAnimations } from '../../theme';

interface MotionContainerProps {
    children: React.ReactNode;
    animationKey?: string | number;
    className?: string;
    style?: React.CSSProperties;
}

export const MotionContainer: React.FC<MotionContainerProps> = ({
    children,
    animationKey,
    className,
    style,
}) => {
    return (
        <motion.div
            key={animationKey}
            initial={modalAnimations.fadeSlide.initial}
            animate={modalAnimations.fadeSlide.animate}
            exit={modalAnimations.fadeSlide.exit}
            transition={modalAnimations.transition}
            className={className}
            style={style}
        >
            {children}
        </motion.div>
    );
};

export default MotionContainer; 